import SweetAlert from 'sweetalert';

function setupSweetAlert($window) {
  $window.swal = SweetAlert;
}

setupSweetAlert.$inject = ['$window'];

export default setupSweetAlert;
